module.exports = __webpack_public_path__ + "img/eb053c6.png";